import React, { useReducer, useContext } from "react";
import AppReducer from "src/reducers/AppReducer";

const AppContext = React.createContext();

const initialState = {
  applist: [],
  sidemenulist: [],
  sidemenuclicked: null,
  helplist: [],
  searchtxt: [],
  group: [],
  list: [],
  listFiltered: [],
  filterGroup: null,
  grouplist: [],
  isexternal: [],
  check: 0,
  perPage: 12,
  pageTotal: 0,
  pageCurrent: 1,
  chk: 0,
};

export function useAppState() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("useAuthState must be used within a AuthProvider");
  }
  return context;
}

const AppContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

export default React.memo(AppContextProvider);
